/**
 * Reads the first present of these query params, trimmed and uppercased.
 * Returns '' if none are present, or if `window`/parsing is unavailable.
 * A plain helper rather than a hook -- how a banner decides it's active
 * (a query param, a date range, a client id) varies enough per banner
 * that it isn't worth forcing into one shared shape.
 */
export function getQueryParam(names: string[]): string {
  try {
    const params = new URLSearchParams(window.location.search);
    for (const name of names) {
      const value = params.get(name);
      if (value !== null) return value.trim().toUpperCase();
    }
  } catch {
    // Ignore if URL parsing fails
  }
  return '';
}
